const ClientsIcon = () => {
  return (
    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.5 13.3872C31.395 13.3697 31.2725 13.3697 31.1675 13.3872C28.7525 13.2997 26.8275 11.3222 26.8275 8.87218C26.8275 6.36968 28.84 4.35718 31.3425 4.35718C33.845 4.35718 35.8575 6.38718 35.8575 8.87218C35.84 11.3222 33.915 13.2997 31.5 13.3872Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6975 26.1272C32.095 26.5297 34.7375 26.1097 36.5925 24.8672C39.06 23.2222 39.06 20.5272 36.5925 18.8822C34.72 17.6397 32.0425 17.2197 29.645 17.6397"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4475 13.3872C10.5525 13.3697 10.675 13.3697 10.78 13.3872C13.195 13.2997 15.12 11.3222 15.12 8.87218C15.12 6.36968 13.1075 4.35718 10.605 4.35718C8.10247 4.35718 6.08997 6.38718 6.08997 8.87218C6.10747 11.3222 8.03247 13.2997 10.4475 13.3872Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 26.1272C9.85252 26.5297 7.21002 26.1097 5.35502 24.8672C2.88752 23.2222 2.88752 20.5272 5.35502 18.8822C7.22752 17.6397 9.90501 17.2197 12.3025 17.6397"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 26.4597C20.895 26.4422 20.7725 26.4422 20.6675 26.4597C18.2525 26.3722 16.3275 24.3947 16.3275 21.9447C16.3275 19.4422 18.34 17.4297 20.8425 17.4297C23.345 17.4297 25.3575 19.4597 25.3575 21.9447C25.34 24.3947 23.415 26.3897 21 26.4597Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9075 31.9722C13.44 33.6172 13.44 36.3122 15.9075 37.9572C18.7075 39.8297 23.2925 39.8297 26.0925 37.9572C28.56 36.3122 28.56 33.6172 26.0925 31.9722C23.31 30.1172 18.7075 30.1172 15.9075 31.9722Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ClientsIcon
